module.exports = __webpack_public_path__ + "img/bbdc-scene-1.85a3c63d.jpg";